import { SvgIcon, SvgIconProps } from '@mui/material';

export const Beam = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 268 321"
      preserveAspectRatio="none"
      sx={{
        width: '268px',
        height: '321px',
        fill: 'none',
        ...sx,
      }}
      {...props}
    >
      <path
        opacity="0.3"
        d="M6.35556 2H82.6222L268 163.246L82.6222 319H0"
        stroke="url(#paint0_linear_13033_17483)"
        strokeWidth="4"
      />
      <defs>
        <linearGradient
          id="paint0_linear_13033_17483"
          x1="268"
          y1="163.246"
          x2="-310.933"
          y2="163.246"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0B90B" />
          <stop offset="1" stopColor="#999999" stopOpacity="0" />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
};
